import React, { createContext, useState } from 'react';

export const LoadingContext = createContext();

export const LoadingProvider = ({ children }) => {
    const [loadingGoogle, setLoadingGoogle] = useState(false);

    return (
        <LoadingContext.Provider value={{ loadingGoogle, setLoadingGoogle }}>
            {children}
        </LoadingContext.Provider>
    );
};
